import axios from "axios";

import Constants from "../../utils/Constantes";
import { eliminarPropiedadObj } from "../../utils/Utils";

const API_URL = Constants.api_url;
const GET_PDF_SOLICITUD_RECONOCIMIENTO = `${API_URL}/jasper/generarPDF_solicitudes`;
const GET_MENSAJES_RECONOCIMIENTO = `${API_URL}/reconocimientoNivel/mostrarReconocimientosFavorableNivelCarreraProfesional`;
const GET_PDF_RECONOCIMIENTOS = `${API_URL}/reconocimientoNivel/mostrarReconocimientosFavorableNivelCarreraProfesionalPDF`;
const INSERT_RECONOCIMIENTOS = `${API_URL}/reconocimientoNivel/guardarBorrador`;
const OBTENER_BORRADOR = `${API_URL}/reconocimientoNivel/obtenerBorrador`;
const UPDATE_BORRADOR = `${API_URL}/reconocimientoNivel/actualizarBorrador`;
const ANULAR_BORRADOR = `${API_URL}/reconocimientoNivel/anular`;
const PRESENTAR_BORRADOR = `${API_URL}/reconocimientoNivel/presentarSolicitud`;
const UPDATE_PRESENTAR_BORRADOR = `${API_URL}/reconocimientoNivel/updateSolicitudPresentada`;
const GET_SOLICITUD_BY_ID = `${API_URL}/reconocimientoNivel/getSolicitudReconocimientoByXwemprecnivcar2021`;
const RESOLVER_SOL = `${API_URL}/reconocimientoNivel/resolverSolicitud`;
const ULT_PRESENT = `${API_URL}/reconocimientoNivel/obtenerCodUltimaSolPresentada`;

export async function getPDFSolicitud(xwemprecnivcar2021) {
 
  return await axios({
    method: "GET",
    url: `${GET_PDF_SOLICITUD_RECONOCIMIENTO}/${xwemprecnivcar2021}`,
    responseType: "blob",
    // params: { xwemprecnivcar2021: xwemprecnivcar2021 },
  }).catch(
    (response) =>
      (response.data = "Error:")
  );
}

export async function getMensajesReconocimientos(x_cabactadm) {
  return await axios({
    method: "GET",
    url: GET_MENSAJES_RECONOCIMIENTO + `/${x_cabactadm}`,
  })
    .then((response) => response.data.data)
    .catch(function () {});
}

export async function getPDFReconocimientos(x_cabactadm) {
  return await axios({
    method: "GET",
    responseType: "blob",
    url: GET_PDF_RECONOCIMIENTOS + `/${x_cabactadm}`,
  }).catch(
    (response) =>
      (response.data = "Error:")
  );
}

export async function insertSolicitudReconocimiento(valores) {
  // 
  if (valores.dni.length === 9) {
    valores.dni = valores.dni.substr(0, valores.dni.length - 1);
  }
  return await axios({
    method: "POST",
    url: INSERT_RECONOCIMIENTOS,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar insertar el borrador")
    );
}

export async function getBorrador(n_iep) {
  if (n_iep === 9) {
    n_iep = n_iep.substr(0, n_iep.length - 1);
  }
  return await axios({
    method: "GET",
    url: `${OBTENER_BORRADOR}/${n_iep}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger los datos del borrador")
    );
}

export async function updateBorrador(valores) {
  
  if (valores.dni.length === 9) {
    valores.dni = valores.dni.substr(0, valores.dni.length - 1);
  }
  
  return await axios({
    method: "POST",
    url: UPDATE_BORRADOR,
    data: valores,
  }).then((response) => response.data);
}

export async function anularBorrador(xwemprecnivcar2021) {
  
  return await axios({
    method: "GET",
    url: `${ANULAR_BORRADOR}/${xwemprecnivcar2021}`,
  }).then((response) => response.data);
}

export async function getSolicitudReconocimientoByXwemprecnivcar2021(
  xwemprecnivcar2021
) {
  // 
  return await axios({
    method: "GET",
    url: `${GET_SOLICITUD_BY_ID}/${xwemprecnivcar2021}`,
  }).then((response) => response.data);
}

export async function presentarSolicitud(valores) {
  // 
  if (valores.dni.length === 9) {
    valores.dni = valores.dni.substr(0, valores.dni.length - 1);
  }
  valores = eliminarPropiedadObj(valores, "tipo");
  return await axios({
    method: "POST",
    url: `${PRESENTAR_BORRADOR}`,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en presentar los datos del borrador")
    );
}

export async function updateSolicitudPresentada(valores) {
  // 
  if (valores.dni.length === 9) {
    valores.dni = valores.dni.substr(0, valores.dni.length - 1);
  }
  return await axios({
    method: "POST",
    url: `${UPDATE_PRESENTAR_BORRADOR}`,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data =
          "Error: Fallo en actulizar los datos del borrador presentado")
    );
}

export async function updateResolucionSolicitud(fechaResolucion) {
  return await axios({
    method: "POST",
    url: `${RESOLVER_SOL}`,
    params:{
      fechaResolucion: fechaResolucion
    }
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data =
          "Error: Fallo en actulizar los datos del borrador presentado")
    );
}

export async function getCodUltimaSolPresentada() {
  // 
  return await axios({
    method: "GET",
    url: `${ULT_PRESENT}`,
  }).then((response) => response.data);
}